import { render } from "./CrawlAtBar.vue?vue&type=template&id=abd687da&scoped=true"
import script from "./CrawlAtBar.vue?vue&type=script&lang=js"
export * from "./CrawlAtBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-abd687da"

export default script